export const AD_EVENT = 'evt';

export const AD_EVENT_DATA = 'd';

export const AD_PLACEMENT_ID = 'pid';
export const AD_ID = 'aid';

export const AD_STATE = 'st';
export const AD_VIEWABLE_PERCENTAGE = 'vp';

export const SESSION_UUID = 'sid';
export const SESSION_TIME = 'sst';

export const AD_TIME_ISO = 'ti';
export const AD_TIME_OFFSET = 'to';

export const DOC_WIDTH = 'dw';
export const DOC_HEIGHT = 'dh';

export const WNDW_WIDTH = 'ww';
export const WNDW_HEIGHT = 'wh';

export const DVCE_SCREENWIDTH = 'sw';
export const DVCE_SCREENHEIGHT = 'sh';

export const DOC_CHARSET = 'dc';

export const BR_LANG = 'lg';

export const DEVICE_ATLAS_STRING = 'ivodd';

export const AD_IS_MRAID = 'md';
export const AD_IS_SAFEFRAME = 'sf';

export const AD_HOST = 'ph';
export const AD_URL = 'pu';
export const AD_PAGE_REFERRER = 'pr';

export const AD_DWELL_TIME = 'dt';

export const AD_ANIMATION_TIME = 'at';
export const AD_ANIMATION_DURATION = 'ad';
export const AD_ANIMATION_PERCENTAGE = 'ap';

export const AD_VIDEO_PERCENTAGE = 'vip';
export const AD_VIDEO_SEEK_TIME = 'vis';
export const AD_VIDEO_MUTED = 'vim';
export const AD_VIDEO_VOLUME_PERCENTAGE = 'viv';
export const AD_VIDEO_TIME = 'vit';
export const AD_VIDEO_DURATION = 'vid';

export const AD_VIEWPORT_WIDTH = 'avw';
export const AD_VIEWPORT_HEIGHT = 'avh';
export const AD_UNIT_LEFT_POSITION = 'apl';
export const AD_UNIT_RIGHT_POSITION = 'apr';
export const AD_UNIT_TOP_POSITION = 'apt';
export const AD_UNIT_BOTTOM_POSITION = 'apb';
export const AD_PARENT_WINDOW_WIDTH = 'apw';
export const AD_PARENT_WINDOW_HEIGHT = 'aph';

export const AD_COMPONENT_ID = 'c';
export const AD_COMPONENT_TYPE = 't';
export const AD_COMPONENT_NAME_BASE64 = 'l2';
export const AD_COMPONENT_NAME = 'l';

export const ORGANISATION_LINE_ITEM_ID = 'tpl';
export const ORGANISATION_INVENTORY_ID = 'tpi';
export const ORGANISATION_AUDIENCE_ID = 'tpid';
export const ORGANISATION_AUDIENCE_SEGMENT_ID = 'tpsid';
export const ORGANISATION_AUDIENCE_CUSTOM = 'tpc';

export const CACHEBUSTER_NAME = 'ord';

export const TRACKING_FIRE_NAMES = [
  AD_EVENT,
  AD_PLACEMENT_ID,
  AD_ID,
  AD_STATE,
  AD_VIEWABLE_PERCENTAGE,
  SESSION_UUID,
  SESSION_TIME,
  AD_TIME_ISO,
  AD_TIME_OFFSET,
  DOC_WIDTH,
  DOC_HEIGHT,
  WNDW_WIDTH,
  WNDW_HEIGHT,
  DVCE_SCREENWIDTH,
  DVCE_SCREENHEIGHT,
  DOC_CHARSET,
  BR_LANG,
  DEVICE_ATLAS_STRING,
  AD_IS_MRAID,
  AD_IS_SAFEFRAME,
  AD_HOST,
  AD_URL,
  AD_PAGE_REFERRER,
  AD_ANIMATION_TIME,
  AD_ANIMATION_DURATION,
  AD_ANIMATION_PERCENTAGE,
  AD_VIDEO_PERCENTAGE,
  AD_VIDEO_SEEK_TIME,
  AD_VIDEO_MUTED,
  AD_VIDEO_VOLUME_PERCENTAGE,
  AD_VIDEO_TIME,
  AD_VIDEO_DURATION,
  AD_VIEWPORT_WIDTH,
  AD_VIEWPORT_HEIGHT,
  AD_UNIT_LEFT_POSITION,
  AD_UNIT_RIGHT_POSITION,
  AD_UNIT_TOP_POSITION,
  AD_UNIT_BOTTOM_POSITION,
  AD_PARENT_WINDOW_WIDTH,
  AD_PARENT_WINDOW_HEIGHT,
  AD_COMPONENT_ID,
  AD_COMPONENT_TYPE,
  AD_COMPONENT_NAME_BASE64,
  AD_COMPONENT_NAME,
  ORGANISATION_LINE_ITEM_ID,
  ORGANISATION_INVENTORY_ID,
  ORGANISATION_AUDIENCE_ID,
  ORGANISATION_AUDIENCE_SEGMENT_ID,
  ORGANISATION_AUDIENCE_CUSTOM,
  CACHEBUSTER_NAME,
];



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/constants/trackingNames.js